import React, { useState } from "react";
import { Link } from "react-router-dom";
import ProcessFlowImage from "./ProcessFlowImage";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import {
  FINANCIAL_DOMAIN_INTRO,
  FINANCIAL_GROUPS,
  FINANCIAL_USE_CASES,
  FINANCIAL_USE_CASES_SEO,
  FINANCIAL_DOMAIN_FAQS,
  FINANCIAL_FAQ_JSONLD,
  FINANCIAL_ITEM_LIST_JSONLD,
  FINANCIAL_DOMAIN_BREADCRUMB_JSONLD,
  FINANCIAL_WEBPAGE_JSONLD,
} from "../../data/financialUseCases";

function ProcessImage({ src, alt }) {
  return <ProcessFlowImage src={src} alt={alt} />;
}

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={
        <ProcessImage
          src={useCase.image}
          alt={`${useCase.title} — ${useCase.imageAlt}`}
        />
      }
    />
  );
}

function GroupSection({ group }) {
  const cases = FINANCIAL_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;

  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>
        <Link
          to={`/agentic-ai/financial-domain/${group.id}`}
          style={{ color: "inherit", textDecoration: "none" }}
        >
          {group.label}
        </Link>
      </h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function FinancialDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");

  const visibleGroups =
    activeFilter === "all"
      ? FINANCIAL_GROUPS
      : FINANCIAL_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={FINANCIAL_DOMAIN_INTRO}
        domainSlug="financial-domain"
        useCaseCount={FINANCIAL_USE_CASES_SEO.length}
        groupCount={FINANCIAL_GROUPS.length}
        itemListJsonLd={FINANCIAL_ITEM_LIST_JSONLD}
        faqJsonLd={FINANCIAL_FAQ_JSONLD}
        breadcrumbJsonLd={FINANCIAL_DOMAIN_BREADCRUMB_JSONLD}
        webPageJsonLd={FINANCIAL_WEBPAGE_JSONLD}
        keywords="financial domain agentic AI, accounts payable automation, accounts receivable, procure to pay, order to cash, treasury, tax automation, FP&A, general ledger close, expense management, audit automation, finance shared services, agentic AI India UAE KSA UK USA"
      />
      <style>{DOMAIN_PAGE_STYLES}</style>

      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{FINANCIAL_DOMAIN_INTRO.title}</h1>
          {FINANCIAL_DOMAIN_INTRO.content ? (
            <p>{FINANCIAL_DOMAIN_INTRO.content}</p>
          ) : null}
        </div>
      </header>

      <UseCaseIndexGrid
        useCases={FINANCIAL_USE_CASES_SEO}
        groups={FINANCIAL_GROUPS}
        heading="Financial Domain Use Cases"
        onFilterChange={setActiveFilter}
      />

      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={FINANCIAL_DOMAIN_INTRO.title}
        domainFaqs={FINANCIAL_DOMAIN_FAQS}
        useCases={FINANCIAL_USE_CASES_SEO}
      />
    </div>
  );
}

